export default "__VITE_ASSET__2e888fc5__"